import React from "react";
import { HighlightCard } from "./highlights/HighlightCard";

export const StoryGrid = ({ stories = [], testId = "story-grid", carousel = false, from, cardTestIdPrefix = testId }) => {
  const unique = [...new Map(stories.filter(s => s.id || s.story_id).map(s => [s.id || s.story_id, s])).values()];
  const seen = new Set();
  return <div data-testid={testId} className={carousel ? "flex gap-5 overflow-x-auto snap-x snap-mandatory pb-4" : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"}>
    {unique.map(item => {
      const story = { ...item, id: item.id || item.story_id };
      const repeated = story.image_url && seen.has(story.image_url);
      if (story.image_url) seen.add(story.image_url);
      return <div key={story.id} className={carousel ? "snap-start shrink-0 w-[min(300px,80vw)] [&>article]:h-full" : "min-w-0 [&>article]:h-full"}>
        <HighlightCard story={story} imageAlreadySeen={repeated} from={from} testIdPrefix={cardTestIdPrefix} />
      </div>;
    })}
  </div>;
};